import { Link as RouterLink, useParams } from "react-router-dom";
import { Box, Button, Chip, Typography } from "@mui/material";
import { FALLBACK_LEARN } from "../data/site";
import { getLearn } from "../services/veysoApi";
import { useApiData } from "../hooks/useApiData";
import FallbackNotice from "../components/FallbackNotice";
import { Card, Cards, HeroPanel, Section, heroButtonSx } from "../components/ui";
import { palette5, tokens } from "../theme";

const TYPES = [
  { key: "cme", type: "CME", title: "CME", sub: "For providers", cta: "Explore CME", bg: palette5.moss[0] },
  { key: "blogs", type: "BLOG", title: "Blogs", sub: "Articles & guides", cta: "Read blogs", bg: palette5.moss[0] },
  { key: "videos", type: "VIDEO", title: "Videos", sub: "VEYSO + expert-led", cta: "Watch videos", bg: palette5.moss[0] },
  { key: "webinars", type: "WEBINAR", title: "Webinars", sub: "VEYSO+ / Precision members", cta: "Join webinars", bg: palette5.navy[0], premium: true },
];

export default function Learn() {
  const { type } = useParams();
  const current = TYPES.find((t) => t.key === type) || null;
  const { data, usingFallback } = useApiData(() => getLearn(), FALLBACK_LEARN);
  const items = (data || []).filter((i) => !current || i.type === current.type);
  return (
    <>
      <HeroPanel theme="moss" eyebrow="VEYSO YOU" title={current ? current.title : "A clear path to understanding"}
        subtitle="Learn from experts. Understand your results. Education for everyone and providers." minHeight={460}
        actions={current ? <Button size="large" component={RouterLink} to="/learn" sx={heroButtonSx("moss")}>All learning</Button> : null} />
      <Section tone="white">
        <FallbackNotice show={usingFallback} />
        {!current && (
          <Cards min={240} sx={{ mb: 6 }}>
            {TYPES.map((t) => (
              <Card key={t.key} sx={{ p: 0, overflow: "hidden", display: "flex", flexDirection: "column" }}>
                <Box sx={{ background: t.bg, color: "#fff", p: 2.5, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <Typography variant="h4" sx={{ fontSize: 24 }}>{t.title}</Typography>
                  {t.premium && <Chip label="Premium" size="small" sx={{ background: "rgba(255,255,255,.25)", color: "#fff" }} />}
                </Box>
                <Box sx={{ p: 2.5, flex: 1, color: tokens.muted }}>{t.sub}</Box>
                <Box sx={{ p: 2.5, pt: 0 }}><Button fullWidth variant="outlined" component={RouterLink} to={`/learn/${t.key}`}>{t.cta}</Button></Box>
              </Card>
            ))}
          </Cards>
        )}
        <Cards min={290}>
          {items.map((i) => (
            <Card key={i.id}>
              <Typography sx={{ fontSize: 12.5, letterSpacing: ".1em", color: tokens.muted }}>{i.type}{i.premium ? " · PREMIUM" : ""}</Typography>
              <Typography variant="h4" sx={{ fontSize: 20, mt: 1 }}>{i.title}</Typography>
              <Typography sx={{ color: tokens.muted, mt: 1, fontSize: 15 }}>{i.summary}</Typography>
              {i.premium && <Typography sx={{ mt: 1.5, fontSize: 14, color: palette5.navy[0] }}>For VEYSO+ and Precision members</Typography>}
            </Card>
          ))}
        </Cards>
      </Section>
    </>
  );
}
